export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_12.f71bf5d6.jpg";